import { useAuth } from "@/services/supabase/auth/AuthContext/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingView } from "../components/LoadingView";

interface RedirectIfAuthenticatedRouteProps {
  children: JSX.Element;
  to: string;
  withRedirect?: boolean;
}

/**
 * a route that redirects the user if they are authenticated
 */
export const RedirectIfLoggedIn = ({ children, to }: RedirectIfAuthenticatedRouteProps) => {
  const { isAuthenticated, isInitialized, isError } = useAuth();
  const location = useLocation();

  if (isError) {
    return <Navigate to="/error" replace />;
  }

  if (isAuthenticated && isInitialized) {
    return <Navigate to={to} replace state={{ from: location }} />;
  }

  if (!isInitialized) {
    return <LoadingView />;
  }

  return children;
};
